'use es6';

import styled from 'styled-components';
import UIAlert from 'UIComponents/alert/UIAlert';
const DeletedMessageBanner = styled(UIAlert).withConfig({
  displayName: "DeletedMessageBanner",
  componentId: "sc-1f80mg5-0"
})(["min-height:40px !important;"]);
export default DeletedMessageBanner;